module.exports = __webpack_public_path__ + "img/casino-asia.9c7daac1.jpg";